import {defaultSelectedParameter} from "../param-tables/state";

export const defaultAccountingConcept = () => {
    return {
        code : null,
        name : null,
        observation : null,
        state : true ,
        accounting_concept_transactions: []
    };
};

export const defaultSelectedAccountingConceptTransaction = () => {
    return {
        accounting_concept_id: null,
        id: null,
        order: null,
        account_id: null,
        transactions_type: null,
        parameter_id: null
    }
}


export default {
    selectedAccountingConcept: defaultAccountingConcept(),
    params: {
        paginate: true,
        perPage: 50,
        filter: '',
        page: 1
    },
    disabledInputs: false,
    action:'create',
    error:false,
    accounting_concepts:[],
    accounts:[],
    actionFormTransactions:'create',
    file: null,
    parameters: [],
    selectedAccountingConceptTransaction: defaultSelectedAccountingConceptTransaction(),
}



// WEBPACK FOOTER //
// ./src/modules/accounting_concept/state.js